// Schreibt das im Custom-Activity-Formular gewählte „Follow-UP Datum“ in das Lead-Feld, auf dem normalen Weg wie die
// Lead-Seite ein Feld ändert (PATCH /api/leads/{id} mit custom). Kein Datum = nichts passiert, das Feld bleibt unverändert.
// Es entsteht keine Aufgabe und kein Inbox-Eintrag; die Smart Views „Follow-UP · Gold/Silber/Bronze“ lesen das Feld.
import { leadsApi, type CustomActivityType } from "../../api";
import { useMeta } from "../../daten/meta";
import { useMeldung } from "../Meldungen";
import { followUpDatum, followUpLeadFeldId } from "./followUpLogik";
import type { Werte } from "./CustomActivityFormular";

/** Liefert `schreiben(leadId, typ, werte, status)`; gibt true zurück, wenn ein Datum geschrieben wurde. Entwürfe schreiben nichts. */
export function useFollowUpSchreiben() {
  const meta = useMeta();
  const meldung = useMeldung();
  return async (leadId: string, typ: CustomActivityType, werte: Werte, status: "published" | "draft"): Promise<boolean> => {
    if (status !== "published") return false;
    const tag = followUpDatum(typ.fields as { id: string; type: string }[], werte);
    if (!tag) return false;
    try {
      await leadsApi.aendern(leadId, { custom: { [followUpLeadFeldId(meta.meta?.custom_fields.lead)]: tag } });
      return true;
    } catch (e) {
      meldung.fehler(e, "Follow-UP Datum nicht gesetzt");
      return false;
    }
  };
}
